
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.172 3.195a4.482 4.482 0 011.055-1.53 2.193 2.193 0 011.554-.618c.625 0 1.37.273 2.235.82.37.235.703.42 1 .555L6.734.719h.907l-.829 1.96c.058.006.115.009.172.009.443 0 .813-.118 1.11-.352.297-.234.596-.599.898-1.094l.625.422c-.224.464-.578.932-1.062 1.406-.485.47-1.073.703-1.766.703-.14 0-.284-.01-.43-.03L5.742 5.21H9.79V6.25H5.336L4.46 8.453h5.328v1.04H4.047l-.563 1.421h-.906l.563-1.422H.164V8.453h3.39L4.43 6.25H.164V5.21h4.672l.719-1.702A6.7 6.7 0 014.5 2.953c-.854-.547-1.508-.82-1.96-.82-.381 0-.714.12-1 .36-.287.239-.54.588-.759 1.046l-.61-.344z","fill":"currentColor"}})])
          )
        }
      }
    